import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ShiftSchedules } from "src/app/models/HR/ShiftSchedules/shiftSchedules.model";
import { IShiftSchedulesRepository } from "./IShiftSchedulesRepository";

@Injectable()
export class ShiftSchedulesRepository 
    extends GenericRepository<ShiftSchedules> 
    implements IShiftSchedulesRepository {

    constructor(protected _http: HttpClient) {
        super(_http, 'api/shiftSchedules', environment.urlAddress);
    }

    // Get all with pagination and optional filterText
    // GetAll(currentPage: number, recordsPerPage: number, filterText: string = ''): Observable<ResponseModel> {
    //     const url = `/SelectAll/${currentPage}/${recordsPerPage}/${filterText}`;
    //     return this.Get(url)
    //         .pipe(map(this.extractData), catchError(this.handleError));
    // }

    
    GetAll(currentPage: number, recordsPerPage: number, filterText: string, completed: number): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText+ '/' + completed)
    }
  

    // Save record (Insert/Update)
    SaveRec(item: ShiftSchedules): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    // Load navigation record (Next, Previous, First, Last)
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        const url = `/NavRec/${navType}/${currentIndex}`;
        return this.GetById(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    // Load single record by ID
    LoadRec(Id: number): Observable<ResponseModel> {
        const url = `/GetRec/${Id}`;
        return this.GetById(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    // Delete record by ID
    DeleteRec(Id: number): Observable<ResponseModel> {
        const url = `/DeleteRec/${Id}`;
        return this.Delete(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    // Search records by name
    Search(name: string): Observable<ResponseModel> {
        const url = `/Search/${name}`;
        return this.GetById(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }
}
